module.exports = __webpack_public_path__ + "static/media/typeform.855e980f.png";